// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base skeleton shimmer animation */
@keyframes shimmer {
    0% {
        background-position: -400px 0;
    }
    100% {
        background-position: 400px 0;
    }
}

.skeleton {
    background: linear-gradient(
        90deg,
        var(--border-light) 25%,
        var(--border) 50%,
        var(--border-light) 75%
    );
    background-size: 800px 100%;
    animation: shimmer 1.5s ease-in-out infinite;
    border-radius: 4px;
}

.skeleton_text {
    height: 14px;
    width: 100%;
    border-radius: 4px;
}

.skeleton_title {
    height: 22px;
    width: 60%;
    border-radius: 4px;
}

.skeleton_circle {
    border-radius: var(--radius-sm);
    flex-shrink: 0;
}

.skeleton_rect {
    border-radius: var(--radius-sm);
}

/* Card container */
.skeleton_card_container {
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    padding: 20px;
    box-shadow: var(--shadow-sm);
}

/* KPI Grid skeleton */
.skeleton_kpi_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    padding: 16px 0 4px;
}

.skeleton_kpi_box {
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    padding: 16px 18px;
    min-height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
}

/* Table skeleton */
.skeleton_table_container {
    display: flex;
    flex-direction: column;
    gap: 0;
    border-radius: var(--radius-md);
    overflow: hidden;
}

.skeleton_table_header {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 16px;
    padding: 14px 16px;
    background-color: var(--bg);
    border-radius: var(--radius-sm) var(--radius-sm) 0 0;
}

.skeleton_table_row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 16px;
    padding: 16px;
    border-bottom: 1px solid var(--border-light);
}

/* Actions grid skeleton */
.skeleton_actions_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    width: 100%;
}

.skeleton_action_box {
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    padding: 18px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
}

.skeleton_action_info {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

/* Broker skeleton */
.skeleton_broker_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
}

.skeleton_broker_section {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.skeleton_broker_card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 18px;
    border-radius: var(--radius-md);
    background-color: var(--bg);
    border: 1px solid var(--border-light);
}

@media (max-width: 1200px) {
    .skeleton_kpi_grid,
    .skeleton_actions_grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .skeleton_kpi_grid,
    .skeleton_actions_grid,
    .skeleton_broker_grid {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/skeleton/skeleton.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI;QACI,6BAA6B;IACjC;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;;;;;KAKC;IACD,2BAA2B;IAC3B,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,mBAAmB;AACnB;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;IAC/B,aAAa;IACb,4BAA4B;AAChC;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,kBAAkB;IAClB,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,aAAa;IACb,4CAA4C;AAChD;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,+BAA+B;IAC/B,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI;;QAEI,qCAAqC;IACzC;AACJ;;AAEA;IACI;;;QAGI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Base skeleton shimmer animation */\n@keyframes shimmer {\n    0% {\n        background-position: -400px 0;\n    }\n    100% {\n        background-position: 400px 0;\n    }\n}\n\n.skeleton {\n    background: linear-gradient(\n        90deg,\n        var(--border-light) 25%,\n        var(--border) 50%,\n        var(--border-light) 75%\n    );\n    background-size: 800px 100%;\n    animation: shimmer 1.5s ease-in-out infinite;\n    border-radius: 4px;\n}\n\n.skeleton_text {\n    height: 14px;\n    width: 100%;\n    border-radius: 4px;\n}\n\n.skeleton_title {\n    height: 22px;\n    width: 60%;\n    border-radius: 4px;\n}\n\n.skeleton_circle {\n    border-radius: var(--radius-sm);\n    flex-shrink: 0;\n}\n\n.skeleton_rect {\n    border-radius: var(--radius-sm);\n}\n\n/* Card container */\n.skeleton_card_container {\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    padding: 20px;\n    box-shadow: var(--shadow-sm);\n}\n\n/* KPI Grid skeleton */\n.skeleton_kpi_grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n    padding: 16px 0 4px;\n}\n\n.skeleton_kpi_box {\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    padding: 16px 18px;\n    min-height: 90px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n/* Table skeleton */\n.skeleton_table_container {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    border-radius: var(--radius-md);\n    overflow: hidden;\n}\n\n.skeleton_table_header {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    gap: 16px;\n    padding: 14px 16px;\n    background-color: var(--bg);\n    border-radius: var(--radius-sm) var(--radius-sm) 0 0;\n}\n\n.skeleton_table_row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    gap: 16px;\n    padding: 16px;\n    border-bottom: 1px solid var(--border-light);\n}\n\n/* Actions grid skeleton */\n.skeleton_actions_grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n    width: 100%;\n}\n\n.skeleton_action_box {\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    padding: 18px 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n}\n\n.skeleton_action_info {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n/* Broker skeleton */\n.skeleton_broker_grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n}\n\n.skeleton_broker_section {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.skeleton_broker_card {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 14px 18px;\n    border-radius: var(--radius-md);\n    background-color: var(--bg);\n    border: 1px solid var(--border-light);\n}\n\n@media (max-width: 1200px) {\n    .skeleton_kpi_grid,\n    .skeleton_actions_grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .skeleton_kpi_grid,\n    .skeleton_actions_grid,\n    .skeleton_broker_grid {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
